<template>
    <div class="content-container pe-3">
    <div :style="{ marginTop: selectedC ? '80px' : '0' }">
        <div class="d-flex align-items-center justify-content-between mx-5" v-if="country.length > 0">
  
</div>
<div class="d-flex flex-row justify-content-evenly">


    <div class="w-100 country-risk flex-column">
        <div class="center-verticaly d-flex flex-column align-items-center justify-content-center mb-1" v-if="Object.keys(data_country).length > 0">
                <ProgressBar :data_country="data_country" currentChartField="opportunity"/>
        </div>
    </div>

</div>
    <div v-if="this.ispartialscore" class="partialscore_text text-center mb-1">
        No sufficient data available for complete assessment.
   </div>
    <!-- <div v-if="this.iscritical === 1" class="embargo_text text-center my-3">
        The Global Country Risk of this country has been penalized because of the embargo measures.
   </div> -->

   <div v-html="sentence" class="autosentence_text center-verticaly d-flex flex-column align-items-center justify-content-center mb-1 m-4">

   </div>
    <div class="wrapper ms-2 my-3 d-flex justify-content-center flex-wrap flex-xl-nowrap col gap-3">
        <div class="col-12 col-xl-6" v-if="Object.keys(data_country).length > 0">
            <SolidGauge :data_country="data_country" currentChartField="opportunity" :chartId="'gaugeOpportunity'"/>
        </div>
        <div class="col-12 col-xl-6 mt-3 mt-xl-0" v-if="Object.keys(all_data_country).length > 0">
            <MapWorld :all_data_country="all_data_country" currentChartField="opportunity"/>
        </div>
    </div>
    <div class="indicator d-block w-100 ms-2" v-if="Object.keys(data_indicator).length > 0 && this.$route.params.element">
        <Indicator
            :selectedC="selectedC"
            :data="data"
            :data_indicator="data_indicator"
            :data_indicator_world="data_indicator_world"
            :data_indicator_region="data_indicator_region"
            currentChartField="opportunity"
        />
    </div>
    <div class="indicator d-block w-100 ms-2" v-if="Object.keys(data_indicator).length > 0 && this.$route.params.element">
        <IndicatorPDF
            :selectedC="selectedC"
            :data="data"
            :data_indicator="data_indicator"
            :data_indicator_world="data_indicator_world"
            :data_indicator_region="data_indicator_region"
        />
    </div>
    </div>

</div>
</template>

<script>
/* eslint-disable */
import ProgressBar from './CountryRisk.vue'
import MapWorld from './CountryMap'
import SolidGauge from './CountryBar'
import MenuDropDown from '../UI/MenuDropDown.vue'
import Indicator from './CountryIndicator'
import IndicatorPDF from './CountryIndicatorPDF.vue'
import RoundGaugeOpportunity from './CountryGauge.vue'
import IndicatorName from "../../views/app_opport.json"

export default {
    components: {
        ProgressBar,
        MapWorld,
        SolidGauge,
        RoundGaugeOpportunity,
        MenuDropDown,
        Indicator,
        IndicatorPDF
    },
    props: {
        selectedC: {
            type: String,
            required: true,
        },
        drapeauURL: {
            type: String,
            required: true,
        },
        data_country: {
            type: Object,
            required: true,
        },
        sentence: {
            type: Object,
            required: true,
        },
        all_data_country: {
            type: Object,
            required: true,
        },
        data_indicator: {
            type: Object,
            required: true,
        },
        data_indicator_world: {
            type: Object,
            required: true,
        },
        data_indicator_region: {
            type: Object,
            required: true,
        }
    },
    data () {
        return {
            country: [],
            data: IndicatorName
        }
    },
    methods: {
        
    },
    mounted() {
    },
}
</script>